import { motion, useReducedMotion } from "framer-motion";
import React from "react";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";

const ellipsisVariants = {
  animate: {
    opacity: [0.2, 1, 0.2],
    transition: {
      repeat: Infinity,
      duration: 1.2,
      staggerChildren: 0.2,
    },
  },
};

const dotVariants = {
  animate: (i: number) => ({
    opacity: [0.2, 1, 0.2],
    transition: {
      repeat: Infinity,
      duration: 1.2,
      delay: i * 0.2,
    },
  }),
};

interface WaitingPageLayoutProps {
  headline: React.ReactNode;
  body: React.ReactNode;
  children?: React.ReactNode;
}

const WaitingPageLayout: React.FC<WaitingPageLayoutProps> = ({
  headline,
  body,
  children,
}) => {
  const animate = useReducedMotion() ? undefined : "animate";
  return (
    <Stack
      align="center"
      justify="center"
      gap={6}
      className="min-h-full w-full px-6 py-8"
    >
      <Text
        variant="display"
        render={<h1 />}
        className="text-center text-balance"
      >
        {headline}
      </Text>
      <Text className="max-w-md text-center text-subtle">{body}</Text>
      {children}
      <motion.span
        className="flex text-3xl leading-[1.1] font-medium tracking-[-0.02em] text-ink"
        variants={ellipsisVariants}
        animate={animate}
      >
        {Array.from({ length: 3 }).map((_, i) => (
          <motion.span
            key={i}
            className="mx-1"
            custom={i}
            variants={dotVariants}
            animate={animate}
          >
            .
          </motion.span>
        ))}
      </motion.span>
    </Stack>
  );
};

export default WaitingPageLayout;
